import React, {useState, useRef, useEffect, Fragment} from 'react';
import { ProgressHeader } from './ProgressHeader';
import {FieldDropdown, TextField, Divider, ViewLabelValueField, UserIcon, VisDiv} from '../../components';


/**
 * StepByStepProgress is a React component that renders a step by step progress 
 * based on an array of objects with a description property. Each step is 
 * rendered as a VisDiv with a rules prop that is set to true if the 
 * description matches the current progressTab state. The component 
 * also renders a header with the current step's description and two buttons 
 * for navigating to the previous and next steps.
 * #core
 * @param {array} progressList - an array of objects with a description property
 * @returns {JSX.Element} - a JSX element with the step by step progress
 */
export const StepByStepProgress = ({progressList}) => {

    const  [progressTab, setProgressTab] = useState(progressList[0])

    const activeIndex = progressList?.findIndex((x)=>x?.description == progressTab?.description)

    const nextStep = () => {
        //console.log("NEXT STEP")
        setProgressTab(progressList[activeIndex+1])
    }
    const previousStep = () => {
        //console.log("PREVIOUS STEP")
        setProgressTab(progressList[activeIndex-1])
    }
  return (
    <div style={{}}>
        <ProgressHeader progressTab={progressTab} setProgressTab={setProgressTab} progressList={progressList}/>
        {progressList?.map?.((item, index)=>{
            return(
                <VisDiv key={index}  rules={[progressTab?.description == item?.description]}>
                    <h3>{item?.description}</h3>
                    {item?.component}
                </VisDiv>
            )
        })}
        <Divider/>
        <VisDiv style={{display:"flex", justifyContent:"space-around"}}>
            <VisDiv>
               {activeIndex>0 && <button className='pdf-button' onClick={previousStep}>PRECEDENTE</button>}
            </VisDiv>
            <VisDiv>
                {activeIndex < progressList?.length - 1 && <button className='pdf-button' onClick={nextStep}>SUCCESSIVO</button>}
            </VisDiv>
        </VisDiv>
      
    </div>
  )

}
